require('./title.css');

export default function Title(props) {
    return (
        <div className="detaipage title">{props.title}</div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Common/Title/Title.js